import { Page } from "@/components/page-base";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Container } from "./styles";
import { HomeCard } from "../components/card";
import { Permissions } from "@/modules/users/models";

export const Home: React.FC = () => {
  return (
    <Page.Root>
      <Page.Header title="Home" key="home" iconPage={<HomeOutlinedIcon />} />
      <Container>
        <div className="section">
          <div className="pair">
            <HomeCard
              icon="ContentPasteSearchOutlined"
              title="Análise de CPF"
              description="Consulte pessoas."
              permission={Permissions.ANALYSIS}
              url="/consult"
            />
            <HomeCard
              icon="CreditCardOutlined"
              title="Créditos"
              description="Compre créditos para consultar."
              permission={Permissions.CREDITS}
              url="/credits"
            />
          </div>
          <div className="pair">
            <HomeCard
              icon="Groups"
              title="Embaixador"
              description="Gerencie as indicações."
              permission={Permissions.AMBASSADOR}
              url="/ambassador"
            />
            <HomeCard
              icon="GavelOutlined"
              title="Critérios"
              description="Defina critérios de análise."
              permission={Permissions.SCENARIOS}
              url="/scenarios"
            />
          </div>
        </div>
        <div className="section" style={{ paddingBottom: "2vh" }}>
          <div className="pair">
            <HomeCard
              icon="PeopleAltOutlined"
              title="Contas"
              description="Gerencie suas contas."
              permission={Permissions.ACCOUNTS}
              url="/accounts"
            />

            <HomeCard
              icon="RecentActorsOutlined"
              title="Usuários"
              description="Gerencie usuários do sistema."
              permission={Permissions.USERS}
              url="/users"
            />
          </div>
          <div className="pair">
            <HomeCard
              icon="History"
              title="Historico"
              description="Histórico de consultas."
              permission={Permissions.HISTORY}
              url="/history"
            />
            <HomeCard
              icon="SettingsOutlined"
              title="Configurações"
              description="Configurações do sistema."
              permission={Permissions.CONFIGURATIONS}
              url="/configurations"
            />
          </div>
        </div>
        <div className="section" style={{ paddingBottom: "2vh" }}>
          <HomeCard
            icon="SupportAgentOutlined"
            title="Suporte"
            description="Gerenciamento do suporte."
            permission={Permissions.SUPPORT}
            url="/suporte"
          />
        </div>
      </Container>
    </Page.Root>
  );
};
